import { lazy } from 'react';

import * as routePath from '../route-path';

const LoginPage = lazy(() => import('modules/auth/Login'));
const ForgotPasswordPage = lazy(() => import('modules/auth/ForgotPassword'));
const SignUpPage = lazy(() => import('modules/auth/SignUp'));
const StaffSetPasswordPage = lazy(() =>
  import('modules/staff/Staff/SetPassword')
);
const JoinOrg = lazy(() => import('modules/user/JoinOrg'));
const SharedAnalyticPage = lazy(() =>
  import('components/Pages/SharedAnalytic')
);
const EstimatorPage = lazy(() => import('components/Pages/Estimator'));

const routes = [
  {
    path: routePath.LOGIN,
    component: LoginPage,
    exact: true,
  },
  {
    path: routePath.FORGOT_PASSWORD,
    component: ForgotPasswordPage,
    exact: true,
  },
  {
    path: routePath.SIGNUP,
    component: SignUpPage,
    exact: true,
  },
  {
    path: routePath.SIGNUP_SET_PASSWORD,
    component: SignUpPage,
    exact: true,
  },
  {
    path: routePath.STAFF_SET_PASSWORD,
    component: StaffSetPasswordPage,
    exact: true,
  },
  {
    path: routePath.SHARED_ANALYTIC,
    component: SharedAnalyticPage,
    exact: true,
  },
  {
    path: routePath.JOIN_ORG,
    component: JoinOrg,
    exact: true,
  },
  {
    path: routePath.ESTIMATOR,
    component: EstimatorPage,
    exact: true,
  },
];

export default routes;
